(function () {
  'use strict';
  if (window.SandlandQuizAnalytics) return;
  window.SandlandQuizAnalytics = { attach: attach };
  function allowed() {
    return !!(window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.analyticsProcessingAllowed());
  }
  function attach(root) {
    if (!root || root.dataset.quizAnalyticsInitialized || (window.Shopify && window.Shopify.designMode) || window.location.search.indexOf('preview_theme_id=') !== -1 || window.top !== window.self) return;
    root.dataset.quizAnalyticsInitialized = '1';
    var endpoint = 'https://admin.sandlandsleep.com/api/quiz-events';
    var current = null;
    function send(body) {
      return fetch(endpoint, { method: 'POST', mode: 'cors', credentials: 'omit', keepalive: true,
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then(function (r) {
        if (!r.ok) throw new Error('Tracking unavailable');
        return r.json();
      });
    }
    function snapshot(run) {
      var body = { run: run.id, version: run.version, sequence: run.sequence, answers: Object.assign({}, run.answers), outcome: run.outcome, product: run.product, intent: run.intent, token: run.token };
      if (!allowed() || !run.token) return;
      run.queue = send(body).catch(function () {
        if (!allowed()) return;
        return send(body).catch(function () {});
      });
    }
    function connect(run) {
      if (!allowed() || run.connecting || run.token) return;
      run.connecting = true;
      run.queue = send({ run: run.id, version: run.version, sequence: 0, answers: {}, outcome: null, product: null, intent: false })
        .then(function (r) { if (!allowed()) return; run.token = r.token; run.sequence++; snapshot(run); })
        .catch(function () {})
        .finally(function () { run.connecting = false; });
    }
    root.addEventListener('sleep-quiz:start', function (e) {
      var d = e.detail || {};
      current = { id: d.quiz_run_id, version: d.quiz_version, sequence: 0, answers: {}, outcome: null, product: null, intent: false, token: null, queue: Promise.resolve(), connecting: false };
      connect(current);
    });
    root.addEventListener('sleep-quiz:answer', function (e) {
      if (!current || current.id !== e.detail.quiz_run_id || current.outcome) return;
      var q = e.detail.question;
      if (['age', 'gender', 'struggle', 'severity', 'mel'].indexOf(q) === -1) return;
      current.answers[q] = e.detail.answer;
      current.sequence++;
      if (current.token) snapshot(current); else connect(current);
    });
    root.addEventListener('sleep-quiz:result', function (e) {
      if (!current || current.id !== e.detail.quiz_run_id) return;
      current.outcome = e.detail.outcome;
      current.product = e.detail.product && e.detail.product.title;
      current.sequence++;
      if (current.token) snapshot(current); else connect(current);
    });
    root.addEventListener('sleep-quiz:cart-intent', intent);
    root.addEventListener('sleep-quiz:cart-added', intent);
    function intent(e) {
      if (!current || current.id !== e.detail.quiz_run_id) return;
      current.intent = true; current.sequence++;
      if (current.token) snapshot(current); else connect(current);
    }
    document.addEventListener('visitorConsentCollected', function () {
      if (!allowed()) { if (current) current.token = null; return; }
      if (current && !current.outcome) connect(current);
    });
    if (window.Shopify && window.Shopify.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error && current) connect(current);
    });
  }
})();
